// extracted by mini-css-extract-plugin
export default {"FloorBody":"styles_FloorBody__nSSZ9","title":"styles_title__NL2-O","input":"styles_input__3Z+t3"};